import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { db } from 'src/config/firebase';
import withRouter from 'src/config/withRouter';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import moment from 'moment';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import { Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FavoriteBorderOutlined } from '@mui/icons-material';
import NoImage from 'src/assets/images/no-pictures.png'
const useStyles = makeStyles(theme=> ({
    card:props=>({
        width: props.width ? props.width : '46%',
        height:'auto',
        borderRadius:'10px',
        backgroundColor:'#fff',
        display:'flex',
        flexDirection:'column',
        boxShadow: '0 2px 7px gainsboro',
        cursor:'pointer',
        marginBottom:'20px',
        borderBottomRightRadius: '4px',
        borderBottomLeftRadius: '4px',
        [theme.breakpoints.down('sm')]:{
            width:'100%'
        },
    }),

    photoDiv:{
        width:'100%',
        position:'relative',
        height:'130px',
        borderTopRightRadius:'10px',
        borderTopLeftRadius:'10px',
        backgroundColor:'#F4F6F8',
        '& img':{
            width:'100%',
            height:'100%',
            borderTopRightRadius:'10px',
            borderTopLeftRadius:'10px',
        }
    },

    marLeft:{
        marginLeft:'20px',
        [theme.breakpoints.between('xs','md')]: {
            marginLeft:'0px'
        }
    },
    marRight:{
        marginRight:'20px',
        [theme.breakpoints.between('xs','md')]: {
            marginRight:'0px'
        }
    },

    marLeft2:{
        marginLeft:'20px',
    },
    marRight2:{
        marginRight:'20px',
    },

    marAR:{
        margin:'0px auto',
        [theme.breakpoints.between('xs','md')]: {
            marginLeft:'0px'
        }
    },
    
    photoStyle:{
        width:'350px',
        position:'relative',
        height:'130px',
        borderTopRightRadius:'10px',
        borderTopLeftRadius:'10px',
        [theme.breakpoints.down('sm')]:{
            width:'250px'
        },
        '& img':{
            width:'100%',
            height:'100%',
            borderTopRightRadius:'10px',
            borderTopLeftRadius:'10px',
        }
    },

    _name:props=>({
        fontSize:'14px',
        color: props.fontDarkColor ? props.fontDarkColor : '#000',
        fontWeight:'bold',
        textTransform:'capitalize',
        fontFamily: "'Cairo', sans-serif",
    }),

    infoDiv:{
        display:'flex',
        flexDirection:'column',
        width:'calc(100% - 20px)',
        padding:'14px 10px'
    },

    onlineDiv:{
        position:'absolute',
        top:'5px',
        right:'41px',
        width:'55px',
        height:'20px',
        backgroundColor:'#0AB8E5',
        cursor:'pointer',
        color:'#fff',
        fontSize:'12px',
        textAlign:'center',
        lineHeight:'19px'
    },

    favIcon:{
        position:'absolute',
        top:0,
        right:'10px',
        color:'#fff',
        fontSize:'1.9em'
    },

    proCard: {
        width: '49%',
        height: 'auto',
        borderRadius: '10px',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 2px 7px gainsboro',
        cursor: 'pointer',
        marginBottom: '20px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}));

// Activity card template
function CategoryCard(props) {
    const isMounted = React.useRef(null);
    const [totalService, setService] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const { t, i18n, cover, name, categoryId, fontDarkColor,history, width, imgCustomClass, cardCustomClass, company } = props;
    const classes = useStyles({fontDarkColor,width});

    const redirectEvent = () => {
        const companyId = company && company.id;
        if(companyId && categoryId) history.push(`/categories/${companyId}/${categoryId}`);
    }
    
    const isRTL = i18n.translator.language;
    moment.locale(isRTL);
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en; 
    const cardClass = clsx({
        [classes.card]: true,
    });
    const photoClass = clsx({
        [classes.photoDiv]: true,
    });
    const productMarginARClass = clsx({
        [cardCustomClass ? classes.marLeft2 : classes.marLeft]: !width,
        [classes.marAR]: width,
    });
    const productMarginENClass = clsx({
        [cardCustomClass ? classes.marRight2 : classes.marRight]: !width,
        [classes.marAR]: width,
    });

    const ProductLoader = () => {
        return (
            (<div className={classes.proCard}>
                <Skeleton
                animation="wave"
                variant="rectangular"
                width={'100%'}
                height={130}
                style={{
                    borderTopRightRadius: '10px',
                    borderTopLeftRadius: '10px',
                }}
                />
                <div className={classes.productInn}>
                {React.Children.toArray(
                    [0, 0, 0].map((v) => (
                    <Skeleton
                        variant="rectangular"
                        width={'100%'}
                        height={20}
                        style={{ margin: '2px 0px' }}
                    />
                    ))
                )}
                </div>
            </div>)
        );
    };



    if(totalService > 0 && !loading) {
        return(
            <div dir={isRTL === 'ar' ? 'rtl' : 'ltr'} className={`${cardClass} ${isRTL === 'ar' ? productMarginARClass : productMarginENClass}`} onClick={redirectEvent}>
                {/* photoDiv */}
                <div className={photoClass}>
                    <div className={classes.onlineDiv} style={{fontFamily}}>{t('companyPage.online')}</div>
                    <FavoriteBorderOutlined className={classes.favIcon} />
                    <ImgLazyLoad>
                        <img alt={name} src={cover ? cover : NoImage} style={{objectFit:!cover ? 'contain' : 'cover'}}/>
                    </ImgLazyLoad>
                </div>
    
                {/* Name section */}
                <div className={classes.infoDiv}>
                    <span className={classes._name} style={{fontFamily:"'Cairo', sans-serif"}}>{name}</span>
                </div>
            </div>
        )
    };
    if(loading) {
        return <ProductLoader />;
    };

    return null;
}

const mapStateToProps = (state) => {
    return {
      company: state.company, // company theme setting
    };
  };

export default withRouter(connect(mapStateToProps,null)(withTranslation('common')(CategoryCard)));